/**
 * main.tsx — 시뮬앱 진입점. AntD(한국어 로케일·테마) + PWA 등록 후 SimApp 마운트.
 * PWA 새 배포 감지 시 "묻고 진행" 방식으로 사용자 확인 후 새로고침한다.
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ConfigProvider, App as AntdApp, Modal } from 'antd'
import koKR from 'antd/locale/ko_KR'
import { registerSW } from 'virtual:pwa-register'
import SimApp from './SimApp'

// PWA 업데이트 — 새 배포 감지 시 "묻고 진행"(사용자 확인 후 새로고침). flutter_sim(WebView)도 동일 적용.
const updateSW = registerSW({
  onNeedRefresh() {
    Modal.confirm({
      title: '새 버전이 있습니다',
      content: '시뮬레이터가 업데이트되었습니다. 지금 새로고침할까요?',
      okText: '새로고침',
      cancelText: '나중에',
      onOk: () => updateSW(true),
    })
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Mame 브랜드 테마 — 메인앱과 동일 팔레트(퍼플 #6750a4, radius 12, 퍼플끼 배경) */}
    <ConfigProvider
      locale={koKR}
      theme={{ token: {
        colorPrimary: '#6750a4', colorInfo: '#6750a4', borderRadius: 12,
        colorBgLayout: '#f4f3f8', colorBorder: '#e6e3ef',
      } }}
    >
      <AntdApp>
        <SimApp />
      </AntdApp>
    </ConfigProvider>
  </StrictMode>,
)
